import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { clearPlayerMainWalletTurnover } from '../../services'
import {
	ClearPlayerTurnoverRequest,
	ClearPlayerTurnoverResponse,
} from '../../../type'

export default function useMutationClearPlayerMainWalletTurnover(
	props?: UseBaseMutationOptions<
		ClearPlayerTurnoverResponse,
		ClearPlayerTurnoverRequest
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.ClearPlayerMainWalletTurnover],
		mutationFn: (payload) => clearPlayerMainWalletTurnover(payload),
		...props,
	})
}
